export default {
  header: {
    primaryColor: '#0B3660',
    secondaryColor: '#F5F5F5',
    highlightColor: '#0B3660',
    backgroundColor: '#F5F5F5',
  },
  body: {
    primaryColor: '#0B3660',
    secondaryColor: '#F5F5F5',
    highlightColor: '#0B3660',
    backgroundColor: '#F5F5F5',
  },
  panel: {
    backgroundColor: '#F5F5F5',
  },
  global: {
    fontFamily: 'SF Pro Display, Inter, sans-serif',
  },
};
